type ChatProvider = 'sendbird' | 'matrix';

interface Config {
  API_HOST?: string;
  API_HOST_DEV?: string;
  SENDBIRD_APP_ID?: string;
  PRO_SANTE_CONNECT_HOST?: string;
  PRO_SANTE_CONNECT_CLIENT_ID?: string;
  PRO_SANTE_CONNECT_AUTH_HOST?: string;
  CHAT_PROVIDER: ChatProvider;
  MATRIX_HS_URL: string;
}

const config: Config = {
  API_HOST: process.env.REACT_APP_API_HOST,
  API_HOST_DEV: process.env.REACT_APP_API_HOST_DEV,
  SENDBIRD_APP_ID: process.env.REACT_APP_SENDBIRD_APP_ID,
  PRO_SANTE_CONNECT_HOST: process.env.REACT_APP_PRO_SANTE_CONNECT_HOST,
  PRO_SANTE_CONNECT_CLIENT_ID:
    process.env.REACT_APP_PRO_SANTE_CONNECT_CLIENT_ID,
  PRO_SANTE_CONNECT_AUTH_HOST:
    process.env.REACT_APP_PRO_SANTE_CONNECT_AUTH_HOST,
  CHAT_PROVIDER: process.env.REACT_APP_CHAT_PROVIDER as ChatProvider || 'sendbird',
  MATRIX_HS_URL: process.env.REACT_APP_MATRIX_HS_URL || 'http://synapse:8008',
};


console.log("Config: ", config)

export default config;
